
/*
 * GLANZIUM® Review-Leiste v4.4 · Sanfter Bewertungswechsel · Progressive Enhancement PILOT
 * Datenquelle: ausschließlich bereits öffentlich ausgegebene Judge.me App-Block-Inhalte.
 * Kein API-Zugriff, keine Secrets, keine Veränderung an Warenkorb, Shopify oder Judge.me.
 * Wenn die Widgetstruktur nicht erkennbar ist, bleibt das Original-Widget vollständig sichtbar.
 */
(() => {
  'use strict';
  if (window.__glanziumReviewStripV4) {
    window.__glanziumReviewStripV4.init();
    return;
  }

  const STORE = { roots: new WeakMap() };
  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const findText = (node, selectors) => {
    for (const selector of selectors) {
      const candidate = node.querySelector(selector);
      if (candidate) {
        const text = clean(candidate.textContent);
        if (text) return text;
      }
    }
    return '';
  };

  const quoteSelectors = [
    '.jdgm-carousel-item__review-content', '.jdgm-carousel-item__review-body',
    '.jdgm-rev-snippet-card__rev-content-wrapper',
    '[class*="testimonial"][class*="text"]', '[class*="review"][class*="text"]',
    '[class*="rev-content"]', '[class*="review-content"]',
    '[class*="review-body"]', '[class*="quote-content"]',
    '[class*="quote-text"]', 'blockquote',
  ];
  const authorSelectors = [
    '.jdgm-carousel-item__reviewer-name',
    '[class*="reviewer-name"]', '[class*="reviewer_name"]',
    '[class*="customer-name"]', '[class*="author-name"]',
    '[class*="reviewer"][class*="name"]',
  ];
  const candidatesSelector = [
    '.jdgm-carousel-item', '.jdgm-rev-snippet-card',
    '.jm-review-item', '[class*="jdgm"][class*="card"]',
    '[class*="testimonial"][class*="card"]',
    '[class*="testimonial"][class*="item"]',
    '[class*="review-card"]', '[class*="review-item"]',
    '[data-review-id]', '[data-reviewid]',
    '.swiper-slide',
  ].join(',');

  function ratingFrom(card) {
    const ratingNode = card.querySelector('[data-score], [data-rating], [aria-label*="star" i], [aria-label*="stern" i]');
    if (ratingNode) {
      const raw = clean(ratingNode.getAttribute('data-score') || ratingNode.getAttribute('data-rating') || ratingNode.getAttribute('aria-label'));
      const match = raw.match(/(?:^|\D)([1-5](?:[.,]\d)?)(?=\D|$)/);
      if (match) return Math.min(5, Math.max(1, Math.round(Number(match[1].replace(',', '.')))));
    }
    const filled = card.querySelectorAll('.jdgm-star.jdgm--on, .jdgm-star.jdgm--half, [class*="star-filled"], [class*="star--filled"], [data-state="filled"]').length;
    return filled >= 1 && filled <= 5 ? filled : null;
  }

  function fromCard(card) {
    let quote = findText(card, quoteSelectors);
    if (!quote) {
      const lines = [...card.querySelectorAll('p, blockquote')]
        .map(n => clean(n.textContent))
        .filter(t => t.length >= 18 && t.length <= 850 && !/^(bewertet|review for|5[.,]0)/i.test(t));
      quote = lines.sort((a,b) => b.length-a.length)[0] || '';
    }
    quote = clean(quote).replace(/^[„“"'\s]+|[„“"'\s]+$/g,'');
    const author = findText(card, authorSelectors);
    const productAnchor = [...card.querySelectorAll('a[href]')].find(a => {
      try {
        const u = new URL(a.getAttribute('href'), location.href);
        const here = location.hostname.replace(/^www\./i,'').toLowerCase();
        const there = u.hostname.replace(/^www\./i,'').toLowerCase();
        return /^https?:$/.test(u.protocol) && here === there && /\/products\//.test(u.pathname);
      }
      catch (_) { return false; }
    });
    const product = productAnchor ? clean(productAnchor.textContent) : '';
    const url = productAnchor ? productAnchor.href : '';
    const rating = ratingFrom(card);
    // Sehr kurze Widget-Labels, fehlender Autorenname oder leere Rezensionen
    // werden nicht als angeblich echte Kundenstimme übernommen.
    if (quote.length < 14 || !author || author.length > 90 || !rating) return null;
    if (quote.length > 900) return null;
    return {quote,author,product,url,rating};
  }

  function extract(source, max) {
    const all = [...source.querySelectorAll(candidatesSelector)];
    const unique = new Map();
    for (const node of all) {
      // Bei verschachtelten Selektoren bevorzugt tiefer liegende Review-Karten lesen.
      if (all.some(other => other !== node && node.contains(other))) continue;
      const item = fromCard(node);
      if (!item) continue;
      const key = (item.author + '|' + item.quote + '|' + item.product).toLowerCase();
      if (!unique.has(key)) unique.set(key, item);
      if (unique.size >= max) break;
    }
    // Manche Widgets erzeugen eine ganze Karte ohne besondere Class am Wrapper.
    return [...unique.values()];
  }

  // Nur Sterne, Name, Bewertungstext und Produktinfo animieren.
  // Der Pfeil bleibt während des Wechsels an derselben Position bedienbar.
  const easePremium = 'cubic-bezier(.22, 1, .36, 1)';
  const motionOff = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  function stopMotion(state) {
    state.motionId += 1;
    for (const animation of state.motion) animation.cancel();
    state.motion = [];
    state.switching = false;
  }

  function sameReviews(a, b) {
    return a.length === b.length && a.every((item, index) => {
      const other = b[index];
      return other && item.author === other.author && item.quote === other.quote &&
        item.rating === other.rating && item.product === other.product && item.url === other.url;
    });
  }

  async function advanceReview(root, state) {
    if (state.switching || state.reviews.length < 2 || !state.render) return;
    const strip = root.querySelector('.gr-strip');
    if (!strip || strip.hidden) return;

    // Keine unnötigen Effekte für Menschen mit reduzierter Bewegung.
    if (motionOff() || typeof strip.animate !== 'function') {
      state.index = (state.index + 1) % state.reviews.length;
      state.render();
      return;
    }

    const cells = ['.gr-person', '.gr-quote', '.gr-product']
      .map(selector => strip.querySelector(selector)).filter(Boolean);
    if (cells.length !== 3 || cells.some(cell => typeof cell.animate !== 'function')) {
      state.index = (state.index + 1) % state.reviews.length;
      state.render();
      return;
    }

    state.switching = true;
    const motionId = ++state.motionId;
    try {
      // 1) Alte Bewertung leicht nach links gleiten und ausblenden.
      const outgoing = cells.map(cell => cell.animate([
        {opacity: 1, transform: 'translate3d(0, 0, 0)'},
        {opacity: 0, transform: 'translate3d(-8px, 0, 0)'}
      ], {duration: 150, easing: 'ease-in', fill: 'forwards'}));
      state.motion = outgoing;
      await Promise.all(outgoing.map(animation => animation.finished.catch(() => {})));
      if (motionId !== state.motionId || !root.isConnected) return;

      const oldHeight = strip.getBoundingClientRect().height;
      state.index = (state.index + 1) % state.reviews.length;
      state.render(); // Ausschließlich die bereits aus Judge.me gelesenen Inhalte.
      const newHeight = strip.getBoundingClientRect().height;

      // 2) Neue Bewertung von rechts sanft einblenden.
      // Erst neue Animationen aktivieren, dann alte Füllzustände entfernen,
      // damit kein einzelner Frame mit hart eingeblendeten Inhalten entsteht.
      const incoming = cells.map(cell => cell.animate([
        {opacity: 0, transform: 'translate3d(10px, 0, 0)'},
        {opacity: 1, transform: 'translate3d(0, 0, 0)'}
      ], {duration: 290, easing: easePremium, fill: 'both'}));
      outgoing.forEach(animation => animation.cancel());

      // Unterschiedlich lange Rezensionen verändern die Höhe ebenfalls sanft.
      const animations = incoming.slice();
      if (Math.abs(newHeight - oldHeight) > 1) {
        animations.push(strip.animate([
          {height: `${oldHeight}px`}, {height: `${newHeight}px`}
        ], {duration: 290, easing: easePremium, fill: 'both'}));
      }
      state.motion = animations;
      await Promise.all(animations.map(animation => animation.finished.catch(() => {})));
    } finally {
      if (motionId === state.motionId) stopMotion(state);
    }
  }

  function activate(root, reviews) {
    const source = root.querySelector('[data-gr-source]');
    const strip = root.querySelector('.gr-strip');
    if (!source || !strip) return;
    const state = STORE.roots.get(root);
    if (!state) return;
    // Judge.me kann auch ohne inhaltliche Änderung DOM-Mutationen auslösen.
    // Nicht mitten in eine laufende Wechselanimation hinein neu rendern.
    if (root.classList.contains('gr-ready') && sameReviews(state.reviews, reviews)) return;
    if (state.switching) stopMotion(state);
    const current = state.reviews[state.index];
    state.reviews = reviews;
    state.index = current ? Math.max(0, reviews.findIndex(r => r.author===current.author && r.quote===current.quote)) : 0;
    const render = () => {
      const r = state.reviews[state.index];
      if (!r) return;
      const stars = strip.querySelector('.gr-stars');
      stars.textContent = '★'.repeat(r.rating) + '☆'.repeat(5-r.rating);
      stars.setAttribute('aria-label',r.rating+' von 5 Sternen');
      strip.querySelector('.gr-author').textContent = r.author;
      strip.querySelector('.gr-quote').textContent = r.quote;
      const link = strip.querySelector('.gr-product-link');
      const label = strip.querySelector('.gr-product-name');
      const productLabel = strip.querySelector('.gr-product-label');
      link.hidden = true;label.hidden = true;
      if (r.product && r.url) {
        link.href = r.url;
        link.textContent = r.product;
        link.title = r.product;
        link.hidden = false;
        productLabel.hidden = false;
        productLabel.textContent = 'Bewertetes Produkt';
      } else {
        label.textContent = 'Shop-Bewertung';
        label.hidden = false;
        productLabel.hidden = true; // Shopbewertungen zeigen nur eine Bezeichnung.
      }
    };
    state.render = render;
    render();
    strip.hidden = false;
    root.classList.add('gr-ready');
    source.setAttribute('aria-hidden','true');
    source.inert = true;
    root.dataset.grStatus = 'bereit';
  }

  function initRoot(root) {
    if (STORE.roots.has(root) || root.dataset.grEnable !== 'true') return;
    const source = root.querySelector('[data-gr-source]');
    if (!source) return;
    const state = {
      reviews: [], index: 0, render: null, observer: null, pending: null,
      switching: false, motionId: 0, motion: []
    };
    STORE.roots.set(root,state);
    const next = root.querySelector('.gr-next');
    if (next) next.addEventListener('click', () => { void advanceReview(root, state); });
    function refresh() {
      state.pending = null;
      if (!root.isConnected) {
        if (state.switching) stopMotion(state);
        state.observer?.disconnect(); return;
      }
      const reviews = extract(source, Number(root.dataset.grMax)||8);
      if(reviews.length >= 2) {
        activate(root,reviews);
      } else {
        if (state.switching) stopMotion(state);
        // Falls Judge.me später Bewertungen entfernt oder seine Ausgabe neu
        // aufbaut: keine alten, möglicherweise nicht mehr publizierten Texte behalten.
        state.reviews = [];
        state.index = 0;
        root.querySelector('.gr-strip').hidden = true;
        root.classList.remove('gr-ready');
        source.removeAttribute('aria-hidden');
        source.inert = false;
        root.dataset.grStatus = 'original-widget';
      }
    }
    state.observer = new MutationObserver(() => {
      if (state.pending === null) state.pending = setTimeout(refresh,240);
    });
    state.observer.observe(source,{childList:true,subtree:true,characterData:true});
    refresh();
  }

  function init() {document.querySelectorAll('[data-gr-review-root]').forEach(initRoot);}
  window.__glanziumReviewStripV4 = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();
